import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";
import { LoginPage, RegisterPage } from "./pages/AuthPages";
import { DashboardPage } from "./pages/DashboardPage";
import { VehiclesPage } from "./pages/VehiclesPage";
import { LocationsPage } from "./pages/LocationsPage";
import { TurfCutsPage } from "./pages/TurfCutsPage";
import { ActivitiesPage } from "./pages/ActivitiesPage";
import { ReportsPage } from "./pages/ReportsPage";
import { CalendarPage } from "./pages/CalendarPage";
import { CostsPage } from "./pages/CostsPage";
import { FarmMapPage } from "./pages/FarmMapPage";
import { TeamPage } from "./pages/TeamPage";
import { RainfallPage } from "./pages/RainfallPage";
import { VarietiesPage } from "./pages/VarietiesPage";
import { OrdersPage } from "./pages/OrdersPage";
import { StoreLayout } from "./pages/store/StoreLayout";
import StoreHomePage from "./pages/store/StoreHomePage";
import VarietyDetailPage from "./pages/store/VarietyDetailPage";
import OrderPage from "./pages/store/OrderPage";
import OrderStatusPage from "./pages/store/OrderStatusPage";
import { Toaster } from "./components/ui/sonner";
import { InstallPrompt } from "./components/InstallPrompt";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public customer website (root) */}
          <Route path="/" element={<StoreLayout><StoreHomePage /></StoreLayout>} />
          <Route path="/shop" element={<Navigate to="/" replace />} />
          <Route path="/shop/varieties/:slug" element={<StoreLayout><VarietyDetailPage /></StoreLayout>} />
          <Route path="/shop/order" element={<StoreLayout><OrderPage /></StoreLayout>} />
          <Route path="/shop/track" element={<StoreLayout><OrderStatusPage /></StoreLayout>} />

          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/vehicles"
            element={
              <ProtectedRoute>
                <Layout>
                  <VehiclesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/locations"
            element={
              <ProtectedRoute>
                <Layout>
                  <LocationsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/turf-cuts"
            element={
              <ProtectedRoute>
                <Layout>
                  <TurfCutsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/activities"
            element={
              <ProtectedRoute>
                <Layout>
                  <ActivitiesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Layout>
                  <ReportsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <ProtectedRoute>
                <Layout>
                  <CalendarPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/costs"
            element={
              <ProtectedRoute>
                <Layout>
                  <CostsPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/farm-map"
            element={
              <ProtectedRoute>
                <Layout>
                  <FarmMapPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/team"
            element={
              <ProtectedRoute requireAdmin>
                <Layout>
                  <TeamPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/rainfall"
            element={
              <ProtectedRoute>
                <Layout>
                  <RainfallPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/varieties"
            element={
              <ProtectedRoute>
                <Layout>
                  <VarietiesPage />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Layout>
                  <OrdersPage />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <InstallPrompt />
    </AuthProvider>
  );
}

export default App;
